// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_PickupNotificationsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/entregas/pickup_notification_history/{item_id}
 */
import type { Orders_PickupNotificationRow } from './Orders_PickupNotificationRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_PickupNotificationsResponseDados {
notifications: Orders_PickupNotificationRow[]
}

export type Orders_PickupNotificationsResponse = ApiResponse<Orders_PickupNotificationsResponseDados>;

registerResponseContract('Orders_PickupNotificationsResponse', {
  notifications: {
    type: 'array',
    required: true,
    items: {
      so_opin_id:            { type: 'number',  required: true },
      so_opin_order_item_id: { type: 'number',  required: true },
      so_opin_channel:       { type: 'string',  required: true },
      so_opin_sent_by:       { type: 'string',  required: true },
      so_opin_sent_by_name:  { type: 'string',  required: false },
      so_opin_message_id:    { type: 'number',  required: false },
      so_opin_notes:         { type: 'string',  required: false },
      so_opin_created_at:    { type: 'string',  required: true },
      so_opin_portal_state:  { type: 'string',  required: false },
    },
  },
})
